import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ComponentsModule } from "../../components/form-components.module";
import { CommonModule } from "@angular/common";
import { UserTypeComponent } from "./user-type.component";
import { RouterModule } from "@angular/router";
import { HttpService } from "src/providers/http.service";
import { MatStepperModule } from "@angular/material/stepper";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";


@NgModule({
  imports: [
    CommonModule,
    MatStepperModule,
    ComponentsModule,
    RouterModule,
    MatRadioModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule
  ],
  declarations: [UserTypeComponent],
  exports: [
    UserTypeComponent,
    MatRadioModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule
  ],
  providers: [HttpService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class UserTypeModule { }
